import { useMutation } from "@shared/lib/hooks";
import { DeliverableConfiguratorService } from "../services/deliverable.configurator.service";
import {
  ICreateDeliverableFormat,
  IUpdateDeliverableFormat,
  IUpdateDeliverableSubtype,
} from "@shared/lib/types";
import { DELIVERABLE_CONFIGURATOR_QUERY_KEY } from "../constants";

export default function useUpdateDeliverableSubtype() {
  const {
    mutate: updateDeliverableSubtype,
    isLoading: isUpdateDeliverableSubtypeLoading,
    error: updateDeliverableSubtypeError,
    isSuccess: isUpdateDeliverableSubtypeSuccess,
    variables: updateDeliverableSubTypeVariables,
  } = useMutation({
    mutationFn: (data: IUpdateDeliverableSubtype) =>
      DeliverableConfiguratorService.updateDeliverableSubtype(data),
    options: {
      skipInvalidation: true,
    },
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: [...DELIVERABLE_CONFIGURATOR_QUERY_KEY],
      });
    },
  });

  return {
    updateDeliverableSubtype,
    isUpdateDeliverableSubtypeLoading,
    isUpdateDeliverableSubtypeSuccess,
    updateDeliverableSubtypeError,
    updateDeliverableSubTypeVariables,
  };
}
